import {
  CurrencyPipe,
  DatePipe,
  DecimalPipe,
  PercentPipe,
} from '@angular/common'
import { NgModule } from '@angular/core'

import { AtnDsFormattedValuePipe as Pipe } from './formatted-value.pipe'

/**
 * @deprecated get rid of this module, once pipe is converted into standalone
 */
@NgModule({
  declarations: [Pipe],
  exports: [Pipe],
  providers: [DecimalPipe, PercentPipe, CurrencyPipe, DatePipe],
})
export class AtnDsFormattedValueModule {}
